// extracted by mini-css-extract-plugin
var _1 = "Qov6krfmAVZIsIN9sDeg";
var _2 = "DXSevI5DMaOgTQwWvhOV";
var _3 = "CURGd3G3qPKnp5vCgFTv";
export { _1 as "center", _2 as "loader", _3 as "rotate" }
